import React from 'react';
import {Box, SimpleGrid, Text} from '@chakra-ui/react';
import {motion} from 'framer-motion';
import Container from "../../../components/Container";

const MotionedBox = motion(Box);

const PortfolioDescription = () => {
    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'}>
                <Container>
                    <MotionedBox
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.4}}
                        layout
                        pt={'120px'}
                        px={['2.5', '5']}
                        pb={['60px', '120px']}
                        position={'relative'}
                    >
                        <SimpleGrid columns={[1, 2]} spacing={'20px'}>
                            <Box>
                                <Text maxWidth={'650px'} fontSize={'sm'} lineHeight={'4'} textAlign="left">
                                    Venrock consists of two separate investment programs: a traditional
                                    venture capital program, focused on early stage investing in healthcare
                                    and technology companies; and a later-stage healthcare program, which
                                    implements a venture capital-like long-term approach to investment
                                    opportunities in small capitalization public companies and late-stage
                                    private healthcare companies. Click <a href="https://www.venrockcp.com/" target="_blank">here</a> for the later-stage healthcare
                                    program website.
                                    <br/>
                                    <br/>
                                    This website is intended solely to provide general information regarding
                                    Venrock and is not an offer or solicitation with respect to the purchase
                                    or sale of any security. The material contained on this website is
                                    intended for financially sophisticated investors. Venrock does not solicit
                                    or make its services generally available to the public. Further, the
                                    information contained on this site, including information regarding
                                    investments and Venrock’s portfolio company experience, may not be relied
                                    on in any manner as legal, tax, accounting or investment advice. Past
                                    performance is not indicative of future results and it should not be
                                    assumed that results for any investments or portfolio companies described
                                    herein will be achieved for other investments or portfolio companies.
                                    Portfolio company information and team member profiles are not considered
                                    to be a complete list. In particular, the portfolio 
                                    companies described herein were selected based, in part, on their positive 
                                    investment performance relative to other Venrock investments. The content 
                                    provided on this site is provided to
                                    users “AS IS”, and Venrock does not make any representation or warranty,
                                    express or implied, as to the accuracy or completeness of the information
                                    contained on this site.
                                </Text>
                            </Box>
                        </SimpleGrid>
                    </MotionedBox>
                </Container>
            </Box>
        </>
    );
};

export default PortfolioDescription;
